import styled from 'styled-components';
import { Button, Table, Typography, Col, Row } from 'antd';
import { StopOutlined } from '@ant-design/icons';

import colors from '../../../styles/colors';

export const TabelaFiltrada = styled(Table)`
  width: 100%;
  .ant-table-thead ::before {
    display: none;
  }
  .ant-table-thead > tr > th {
    border-bottom: 2px solid #cacaca;
    background-color: ${colors.branco};
    color: ${colors.blue};
  }
  .ant-table table {
    padding-right: 6px;
  }
  .ant-table-tbody > tr > td {
    border-bottom: none;
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
    padding: 4px;
  }
  div::-webkit-scrollbar {
    width: 8px;
    border-radius: 20px;
    border: none;
  }

  div::-webkit-scrollbar-track {
    background: #f4f4f4;
    border-radius: 20px;
  }
  div::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
    border-radius: 20px;
  }
  .ant-table-cell-scrollbar {
    display: none;
  }
  .ant-pagination,
  .ant-table-pagination,
  .ant-table-pagination-right {
    li,
    button {
      :hover {
        border-color: ${colors.verde};
        a {
          color: ${colors.verde};
        }
      }
    }

    .ant-pagination-item-active {
      font-weight: 500;
      background: #fff;
      border-color: ${colors.verde};
      a {
        color: ${colors.verde};
      }
    }
  }
`;

export const LabelStatus = styled(Typography.Text)`
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  color: ${props => props.cor || '#707070'};
`;

export const ButtonVerSolicitacao = styled(Button)`
  background-color: ${colors.verde} !important;
  color: ${colors.branco} !important;
  border-radius: 2px !important;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  border: none;
  height: auto;
  padding: 0.5px 6px;
  &:hover {
    transform: scale(1.2);
  }
`;

export const TituleContainernotData = styled(Col)`
  width: 100%;
  height: 50px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
`;

export const TituleBoxnotData = styled(Row)`
  height: 60;
  width: 80%;
  background-color: #f3f3f375;
  justify-content: center;
  align-items: center;
`;

export const TituleNotData = styled.p`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #0d3549;
  margin: 0;
`;

export const BtnCancelar = styled(StopOutlined)`
  background-color: ${colors.branco} !important;
  color: ${colors.verde} !important;
  &:hover {
    transform: scale(1.3);
  }
`;
